export default __webpack_public_path__ + "static/folds-67cf016a7beb6ffb2cd0ece6a1fab193.png";